export default __webpack_public_path__ + "img/Montserrat-SemiBold_8771894.ttf";